<div>
  <snelstart-ui-alert>
    Toeslagen worden per maand berekend, vandaar dat de gegevens van de partner per maand worden uitgevraagd.
    <br/>Let er wel op dat je bij inkomen en vermogen de bedragen voor geheel {{ this.year }} invult.
  </snelstart-ui-alert>
</div>

<form [formGroup]="inkomenFg">
  <div formArrayName="inkomensgegevens">
    <div *ngFor="let item of inkomensgegevens.controls; let i = index" [formGroupName]="i">
      <div class="row">
        <div class="col-auto">
          @if(i === 0) {
            <div style="width: 150px" class="pt-4">
              {{ this.getLabel(i + 1) }}
            </div>
          } @else {
            <div style="width: 150px" class="pt-1">
              {{ this.getLabel(i + 1) }}
            </div>
          }
        </div>
        <div class="col-auto">
          <snelstart-ui-bsn-form-control (change)="saveForm()"
                                         [label]="i === 0 ? 'Burgerservicenummer' : ''"
                                         class="custom-input-150"
                                         formControlName="bsnPartner"
                                         id="bsn-{{i}}"
          >
          </snelstart-ui-bsn-form-control>
        </div>
        <div class="col-auto">

          <snelstart-ui-date-form-control (change)="saveForm()"
                                          [label]="i === 0 ? 'Geboortedatum' : ''"
                                          class="custom-input-150"
                                          formControlName="geboortedatumPartner"
                                          id="geboortedatumPartner-{{i}}"
                                          placeholder="dd-mm-jjjj"
          >
          </snelstart-ui-date-form-control>
        </div>
        <div class="col-auto">
          <snelstart-ui-number-form-control (change)="saveForm()"
                                            [label]="i === 0 ? this.label1 : ''"
                                            [showAllDecimals]="false"
                                            align="right" class="custom-input-150" formControlName="toetsinkomenPartner"
                                            id="toetsinkomenPartner-{{i}}"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto">
          <snelstart-ui-number-form-control (change)="saveForm()"
                                            [label]="i === 0 ? this.label2 : ''"
                                            [showAllDecimals]="false"
                                            align="right" class="custom-input-150"
                                            formControlName="toetsvermogenPartner"
                                            id="toetsvermogenPartner-{{i}}"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto">
          <snelstart-ui-select-form-control (change)="saveForm()"
                                            [label]="i === 0 ? 'Zorgverzekering Ned.?' : ''"
                                            [options]="optionsJaNee"
                                            class="custom-input-150"
                                            formControlName="partnerHeeftZorgverzekering"
                                            id="partnerHeeftZorgverzekering-{{i}}"
          >
          </snelstart-ui-select-form-control>
        </div>
        <div class="col-auto">
          <snelstart-ui-button (click)="copyFromPrevious(i)"
                               icon="copy"
                               [class]="i===0 ? 'firstrowbutton' : ''"
                               [disabled]="i===0"
                               style="padding-top: 4px"
                               type="secondary"
          >
          </snelstart-ui-button>
        </div>
      </div>
    </div>
  </div>
</form>

